// base
import React from 'react';

// assets
import './transactionsInputData.scss';

import abiDecoder from 'abi-decoder';

const TransactionsInputData = (props) => {
  const { abi } = props;

  var data;
  if (abi) {
    try {
      const { input } = props;
      abiDecoder.addABI(JSON.parse(abi));
      data = abiDecoder.decodeMethod(input);
    } catch(error) {
      console.warn(error);
    }
  }

  return (
    <div className="TransactionsInputData">
      {
        data &&
        <div className='responsive_table'>
          <div className='methodName'>
            <span style={{ fontWeight: 'bold' }}>Method:</span> {data.name}
          </div>
          <table className={'table_type02 TransactionsInputDataComponent'}>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Type</th>
                <th>Data</th>
              </tr>
            </thead>
            <tbody>
            {
              data.params.map((param, i) => (
                <tr key={i}>
                  <td>{i}</td>
                  <td>{param.name}</td>
                  <td>{param.type}</td>
                  <td>{param.value}</td>
                </tr>
              ))
            }
            </tbody>
          </table>
        </div>
      }
    </div>
  )
}

export default TransactionsInputData;
